module.exports = __webpack_public_path__ + "static/media/spoonerism-task (2).6d462561.mp3";